import request from "./http";

class BankAccountRepository
{
    async create(bankAccount) {
        const path = "bank-accounts/create";
        const method = "POST";
        const data = bankAccount;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async edit(bankAccount) {
        const path = "bank-accounts/edit";
        const method = "POST";
        const data = bankAccount;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("edit", error);
        }
    }

    async remove(bankAccount) {
        const path = "bank-accounts/remove";
        const method = "POST";
        const data = bankAccount;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("edit", error);
        }
    }

    async getOneById(id) {
        const path = "bank-accounts/get";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async getAll(partyId = 0) {
        const path = "bank-accounts";
        const method = "GET";
        const data = partyId ? { party_id: partyId } : null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async gridview(query) {
        const path = "bank-accounts/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async zeroOutBonCards(destinationBankAccountId, bonCardIds) {
        const path = "bank-accounts/bon-cards/zero-out";
        const method = "POST";
        const data = {
            destination_bank_account_id: destinationBankAccountId,
            bon_cards: bonCardIds
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async chargeBonCards(originBankAccountId, bonCardIds) {
        const path = "bank-accounts/bon-cards/charge";
        const method = "POST";
        const data = {
            origin_bank_account_id: originBankAccountId,
            bon_cards: bonCardIds
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async getBonCardTransactions(id, from, to) {
        const path = "bank-accounts/bon-card/transactions";
        const method = "GET";
        const data = {
            id: id,
            from: from.toLocaleDateString('en-CA'),
            to: to.toLocaleDateString('en-CA')
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async getBonCardReceipts(from, to, referenceCode) {
        
        const path = "bank-accounts/bon-card/receipts";
        const method = "GET";
        const data = {
            from: from.toLocaleDateString('en-CA'),
            to: to.toLocaleDateString('en-CA'),
            reference_code: referenceCode
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("getBonCardReceipts", error);
        }
    }

    async getBalance(id) {
        const path = "bank-accounts/balance";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("balance ", error);
        }
    }

    async getTransactions(id, from, to) {
        const path = "bank-accounts/transactions";
        const method = "GET";
        const data = {
            id: id,
            from: from.toLocaleDateString('en-CA'),
            to: to.toLocaleDateString('en-CA')
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async getIBANInfo(iban) {
        const path = "bank-accounts/iban-info";
        const method = "GET";
        const data = {
            iban: iban
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async getDiffTransactions(id, from, to) {
        const path = "bank-accounts/diff-transactions";
        const method = "GET";
        const data = {
            id: id,
            from: from.toLocaleDateString('en-CA'),
            to: to.toLocaleDateString('en-CA')
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("diff-transactions", error);
        }
    }

    async getStatements(query) {
        const path = "bank-accounts/statements";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get statements", error);
        }
    }
    
    async importTransactions(bankAccount, transactions) {
        const path = "bank-accounts/import-transactions";
        const method = "POST";
        const data = {
            bank_account_id: bankAccount.id,
            transactions: transactions
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }
}

export default BankAccountRepository;